import superagent from 'superagent'
import { isAuthorized, getUserId, destroyUser } from 'utils/Auth'

const methods = ['get', 'post', 'put', 'patch', 'del']

export default class ApiCall {
  constructor() {
    // eslint-disable-next-line no-return-assign
    methods.forEach(method =>
      this[method] = ({
        params,
        data,
        shuttleUrl,
      } = {}) =>
        new Promise((resolve, reject) => {
          const request = superagent[method](shuttleUrl)
          const auth = isAuthorized() ? `JWT ${JSON.parse(isAuthorized())}` : ''
          const userId = isAuthorized() ? JSON.parse(getUserId()) : ''

          if (params) {
            request.query(params)
          }

          if (data) {
            request.send({
              ...data,
              authorization: data.injectToken ? data.injectToken : auth,
              userId: data.userId ? data.userId : userId,
            })
          }

          const cbRequest = (err, response = {}) => {
            const { body, text } = response
            if (err) {
              const tempBody = body || err
              const respText = text ? JSON.parse(text) : text
              const rejectValue = {
                ...tempBody,
                ...respText,
              }
              if (rejectValue.status === 401 && (rejectValue.data.code === 'OAuthException' || rejectValue.data.code === 'TOKEN_NOT_FOUND')) {
                destroyUser()
                return window.location.replace('/')
              }
              return reject(rejectValue)
            }
            return resolve(body)
          }

          request.end(cbRequest)
        },
    ))
  }
}
